// src/api/meeting.js
import { BASE_API } from "../utils/constants";

/** Listar reuniones */
export async function getMeetingsApi(token) {
  const url = `${BASE_API}/meetings/`;
  const res = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) throw new Error(`Error al obtener reuniones (${res.status})`);
  return res.json();
}

/** Obtener una reunión por id */
export async function getMeetingApi(id, token) {
  const url = `${BASE_API}/meetings/${id}/`;
  const res = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok)
    throw new Error(`Error al obtener la reunión ${id} (${res.status})`);
  return res.json();
}

/** Crear reunión (POST /meetings/) */
export async function addMeetingApi(data, token) {
  const url = `${BASE_API}/meetings/`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`Error al crear reunión (${res.status}): ${text}`);
  }
  return res.json();
}

/** Actualizar reunión (PATCH /meetings/:id/) */
export async function updateMeetingApi(id, data, token) {
  const url = `${BASE_API}/meetings/${id}/`;
  const res = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(
      `Error al actualizar reunión ${id} (${res.status}): ${text}`
    );
  }
  return res.json();
}

/** Eliminar reunión (DELETE /meetings/:id/) */
export async function deleteMeetingApi(id, token) {
  const url = `${BASE_API}/meetings/${id}/`;
  const res = await fetch(url, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok)
    throw new Error(`Error al eliminar reunión ${id} (${res.status})`);
  return true;
}

/** Asignar foto de portada (POST /meetings/:id/set_cover_photo/) */
export async function setCoverPhotoApi(meetingId, photoId, token) {
  const url = `${BASE_API}/meetings/${meetingId}/set_cover_photo/`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ photo_id: photoId }),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`Error al asignar portada (${res.status}): ${text}`);
  }
  return res.json();
}
